/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityKeyBIcon16Solid = forwardRef('SecurityKeyBIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 12.5A4.502 4.502 0 0 0 8.889 9h.361a.5.5 0 0 1 .4.2l.948 1.265a.5.5 0 0 0 .802-.002l.69-.928a.5.5 0 0 1 .8-.003l.686.906a.5.5 0 0 0 .815-.024l1.382-2.073a.5.5 0 0 0-.063-.63l-1.564-1.565A.5.5 0 0 0 13.793 6h-5.26A4.5 4.5 0 1 0 4.5 12.5Zm0-2.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" })));
});
